<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/material/inventory/pageAvailbleInventory" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('cangkumingcheng')">
            <yi_cross_select :max="1" :selectTitle="'name'" :component="'web_wms_purchase_receipt_check_warehouse_code'" :ids.sync="yt.conditions.warehouseId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('kuqumingcheng')">
            <yi_cross_select :max="1" :selectTitle="'name'" :component="'web_wms_purchase_receipt_check_warehouse_area_code'" :ids.sync="yt.conditions.warehouseAreaId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('kuweimingcheng')">
            <yi_cross_select :max="1" :selectTitle="'name'" :component="'web_wms_purchase_receipt_check_warehouse_location_code'" :ids.sync="yt.conditions.warehouseLocationId"> </yi_cross_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ materialId: $attrs.inventory.materialId, unit: $attrs.inventory.unit, colorNo: $attrs.inventory.colorNo })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_wms_delivery_issue_check_select_inventory',
  components: {},
  props: {
    // 生产配置-产品色号管理
    colorNoEnable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns: [
        {
          label: 'wuliaobianma',
          prop: 'material.code',
          width: 150
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name'
        },
        {
          label: 'sehao',
          prop: 'colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          width: 130,
          show: this.colorNoEnable
        },
        {
          label: 'chanpinfenlei',
          prop: 'material.value',
          type: 'dictionary',
          key: 'GYLXCPFL',
          width: 150
        },
        {
          label: 'cangkubianma',
          prop: 'warehouse.code'
        },
        {
          label: 'cangkumingcheng',
          prop: 'warehouse.name'
        },
        {
          label: 'cangkudizhi',
          prop: 'warehouse.address'
        },
        {
          label: 'kuqubianma',
          prop: 'warehouseArea.code'
        },
        {
          label: 'kuqumingcheng',
          prop: 'warehouseArea.name'
        },
        {
          label: 'kuweibianma',
          prop: 'warehouseLocation.code'
        },
        {
          label: 'kuweimingcheng',
          prop: 'warehouseLocation.name'
        },
        {
          label: 'danwei',
          prop: 'unit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE'
        },
        {
          label: 'zongshu',
          prop: 'total'
        },
        {
          label: 'keyongshu',
          prop: 'available'
        },
        {
          label: 'yifenpeishu',
          prop: 'allocated'
        },
        {
          label: 'gongyingshangmingcheng',
          prop: 'supplier.name'
        },
        {
          label: 'wuliaopicihao',
          prop: 'materialBatchNo'
        },
        {
          label: 'shengchanpicihao',
          prop: 'productionBatchNo'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        materialId: this.$attrs.inventory.materialId,
        unit: this.$attrs.inventory.unit,
        colorNo: this.$attrs.inventory.colorNo
      };
      this.yt.SELECT_URL = '/web/material/inventory/listByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'name';
      this.yt.get(1);
    }, 300);
  },
  mounted() {
    console.log('this.inventory', this.$attrs.inventory);
  },
  methods: {}
};
</script>
